import { styled } from '@mui/material';

export const ContentW = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  justify-content: center;
  margin-top: 16px;

  @media (max-width: 1023px) {
    margin-top: 16px;
    flex-direction: column;
  }
`;

export const FormW = styled('div')`
  width: 672px;
  position: relative;
  border-radius: 15px;
  padding: 24px;
  z-index: 0;
  border: 1px solid #ddd;

  &:before {
    content: '';
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    border-radius: 15px;
    z-index: -1;
  }

  @media (max-width: 1023px) {
    width: 100%;
    padding: 16px 8px;
  }
`;
